import React from 'react'
import {Nav, Navbar, NavItem} from 'react-bootstrap'
import style from './Layout.scss'

const RegisterLayout = ({children}) => {
  return (
    <>
      <Navbar className={`me-auto ${style.topBar}`}>
        <Nav className="me-auto">
          <NavItem className={style.brand}>名刺R</NavItem>
        </Nav>
        <Nav className="justify-content-end">
        </Nav>
      </Navbar>
      <div className="contents">
        <section className={style.pageContainer}>
          <main>{children}</main>
        </section>
      </div>
    </>
  )
}

export default RegisterLayout
